import React from 'react'
import { Links } from './Links'
import { Inquiry } from './Inquiry'
import styles from './Footer.module.scss'

export const StyledFooter: React.FC = () => {
  return (
    <footer className={`w-full flex flex-col justify-center border-t-1 border-member-gray-20 desktop:flex-row ${styles.footer}`}>
      <Links />
      <Inquiry />
    </footer>
  )
}
